import { Component, OnInit, Input, Output } from '@angular/core';
import { ApiShow } from '@tytapp/api';
import { BaseComponent } from '@tytapp/common';
import { Subject, Observable } from 'rxjs';

@Component({
    selector: 'app-shows',
    templateUrl: './shows.component.html',
    styleUrls: ['./shows.component.scss']
})
export class ShowsComponent extends BaseComponent implements OnInit {

    @Output()
    get showActivated(): Observable<ApiShow> {
        return this._showActivated;
    }

    private _showActivated: Subject<ApiShow> = new Subject<ApiShow>();
    private _shows: ApiShow[] = [];

    @Input()
    get shows(): ApiShow[] {
        return this._shows;
    }

    set shows(value: ApiShow[]) {
        this._shows = value;
        this.updateShows();
    }

    popularShows: ApiShow[];
    allShows: ApiShow[];

    updateShows() {
        this.popularShows = this._shows.slice(7);
        this.allShows = this._shows.slice().sort((a, b) => a.name == b.name ? 0 : (a.name > b.name ? 1 : -1));
    }

    public activateShow(show: ApiShow, event: MouseEvent) {
        this._showActivated.next(show);
    }
}
